import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, SharedColors, NeutralColors, Stack, Nav, ImageIcon, Icon, Text } from '@fluentui/react';
import AllPanelHeader from './Header/Header.esm.js';
import { imageMap } from '../../../data/images.esm.js';
import { useContext } from 'react';
import { AppContext } from '../../context/context.esm.js';
import { convertTitleToId } from '../utils.esm.js';
import { useTranslation } from 'react-i18next';
import logger from '@agoras/logger';
import { headerContext } from '../context.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var noop = function() {
    return undefined;
};
var classNames = mergeStyleSets({
    icon: {
        width: 0,
        height: 0
    },
    navText: {
        color: 'inherit'
    }
});
var navStyles = {
    groupContent: {
        marginTop: 20,
        marginBottom: 0,
        animation: 'none'
    },
    link: {
        color: NeutralColors.gray160,
        '&:hover': {
            color: SharedColors.cyanBlue10
        }
    }
};
function AllPanelSection(param) {
    var title = param.title, filtersList = param.filtersList, url = param.url, _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? noop : _param_onClick;
    var navigate = useContext(AppContext).navigate;
    var navLinkGroups = filtersList.map(function(param) {
        var icon = param.icon, filterTitle = param.title, _param_url = param.url, filterType = _param_url.filterType, key = _param_url.key, value = _param_url.value, query = _param_url.query;
        return {
            name: filterTitle,
            icon: icon,
            iconProps: {
                className: classNames.icon
            },
            onClick: function() {
                logger.info(JSON.stringify({
                    key: title,
                    name: filterTitle
                }), _object_spread({
                    action: 'AllMenu',
                    actionModifier: 'Click'
                }, headerContext));
                navigate({
                    type: filterType,
                    query: query !== null && query !== void 0 ? query : _define_property({}, "".concat(key), value)
                });
                onClick();
            },
            ariaLabel: filterTitle,
            key: convertTitleToId(filterTitle),
            url: ''
        };
    });
    var t = useTranslation('header').t;
    return /*#__PURE__*/ jsxs(Stack, {
        children: [
            /*#__PURE__*/ jsx(AllPanelHeader, {
                onClick: onClick,
                title: title,
                url: url
            }),
            /*#__PURE__*/ jsx(Nav, {
                styles: navStyles,
                ariaLabel: "".concat(title, " items"),
                groups: [
                    {
                        links: navLinkGroups
                    }
                ],
                selectedKey: "",
                onRenderLink: function(link) {
                    var _ref = link || {}, icon = _ref.icon, name = _ref.name;
                    var svgIcon = imageMap[icon || ''];
                    return /*#__PURE__*/ jsxs(Stack, {
                        horizontal: true,
                        tokens: {
                            childrenGap: 12
                        },
                        verticalAlign: "center",
                        children: [
                            svgIcon ? /*#__PURE__*/ jsx(ImageIcon, {
                                imageProps: {
                                    src: svgIcon,
                                    'aria-label': icon,
                                    alt: icon,
                                    width: 16,
                                    height: 16
                                }
                            }) : icon ? /*#__PURE__*/ jsx(Icon, {
                                iconName: icon,
                                styles: {
                                    root: {
                                        fontSize: 16,
                                        color: SharedColors.cyanBlue10
                                    }
                                }
                            }) : null,
                            /*#__PURE__*/ jsx(Text, {
                                className: classNames.navText,
                                children: t(name !== null && name !== void 0 ? name : '')
                            })
                        ]
                    }, "".concat(name, "-").concat(icon));
                }
            })
        ]
    });
}

export { AllPanelSection as default };
